import { useNavigate } from "react-router";
import { CircleCheck, Video } from "lucide-react";
import { Dialog } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import MyDialogContent from "@/components/MyDialogContent";

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  meetingLink?: string;
};

export function TelehealthBookedDialog({
  open,
  onOpenChange,
  meetingLink = "",
}: Props) {
  const navigate = useNavigate();
  const link = meetingLink.trim();

  const goToAppointment = () => {
    onOpenChange(false);
    if (!link) return;
    navigate("/telehealth/room", { state: { room: link } });
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <MyDialogContent heading="" showCloseButton={false} className="sm:max-w-md">
        <div className="flex flex-col items-center px-2 pb-2 pt-4 text-center">
          <div className="flex h-14 w-14 items-center justify-center rounded-full bg-[#DCFCE7]">
            <CircleCheck className="h-8 w-8 text-[#16A34A]" />
          </div>
          <h2 className="mt-4 text-lg font-semibold text-[#111827]">
            Appointment Booked Successfully!
          </h2>
          <p className="mt-1 text-sm text-muted-foreground">
            Notification alerts have been dispatched to the patient and provider.
          </p>
          <div className="mt-6 flex flex-wrap items-center justify-center gap-2">
            {/* <Button type="button" onClick={goToAppointment}>
              <Video className="h-4 w-4" />
              Go to this Appointment
            </Button> */}
            <Button type="button"  onClick={() => onOpenChange(false)}>
              Close this Popup
            </Button>
          </div>
        </div>
      </MyDialogContent>
    </Dialog>
  );
}
